import { IMAGE_URL } from '@/constant/IMAGE'
import { ColumnsType } from 'antd/lib/table'
import { validatePerm } from '@/libs/validatePermission'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import userAtom from '@/recoil/user'
import { useListHealthClaimApproveLevel } from '@/services/healthClaim/useListHealthClaimApproveLevel'
import deleteSystemApprovalAtom from '@/recoil/deleteSystemApprovalModal'
import { DeleteIcon, EditIcon, ToolWrapper } from './styles'
import createClaimApprovalLevelModalAtom from '@/recoil/createClaimApprovalLevelModal'

const TableSystemApprovalHook = () => {
  const setDeleteSystemApprovalModal = useSetRecoilState(deleteSystemApprovalAtom)
  const user = useRecoilValue(userAtom)
  const queryListHealthClaimUserApprove = useListHealthClaimApproveLevel()
  const setCreateClaimApprovalLevelModal = useSetRecoilState(createClaimApprovalLevelModalAtom)

  const handelOpenDeleteModal = (backofficeUserId: string, fullname: string) => {
    return setDeleteSystemApprovalModal({
      open: true,
      backofficeUserId,
      fullname,
      onSuccess: () => {
        queryListHealthClaimUserApprove.refetch()
      },
    })
  }

  const columns: ColumnsType<any> = [
    {
      title: 'ลำดับ',
      align: 'center',
      render: (_value, _record, index) => {
        return index + 1
      },
      width: 90,
    },
    {
      title: 'ระดับการอนุมัติ',
      width: 200,
      render: (_value, record) => {
        return `${record.name}`
      },
    },
    {
      title: 'จำนวนวงเงิน',
      dataIndex: 'amountDisplay',
      width: 150,
      render: (_value, record) => record.amountDisplay || '-',
    },
    {
      title: '',
      width: 150,
      render: (_value, record) => {
        return (
          <ToolWrapper>
            {validatePerm([BACKOFFICE_USER_PERMISSION.APP010203], user.permissions) ? (
              <EditIcon
                src={IMAGE_URL.editIcon}
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation()

                  if (!record) return
                  setCreateClaimApprovalLevelModal({
                    open: true,
                    record: record,
                    onSuccess: () => {
                      queryListHealthClaimUserApprove.refetch()
                    },
                  })
                }}
              />
            ) : null}
            {validatePerm([BACKOFFICE_USER_PERMISSION.APP010204], user.permissions) ? (
              <DeleteIcon
                src={IMAGE_URL.trashIcon}
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation()
                  handelOpenDeleteModal(record.id, `${record.name}`)
                }}
              />
            ) : null}
          </ToolWrapper>
        )
      },
    },
  ]
  return {
    columns,
    queryListHealthClaimUserApprove,
    validatePerm,
    BACKOFFICE_USER_PERMISSION,
    user,
    setCreateClaimApprovalLevelModal,
  }
}

export default TableSystemApprovalHook
